import * as React from 'react';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { IGetState, TCardId } from '../../../../../../../../../types/types';
import { cardClick } from '../../../../../../../base/effects/cardClick';
import {
    SegmentCardEvent,
    SegmentCardOptions,
    segmentTrackAction
} from '../../../../../../../../../middlewares/segment';
import { cardsActionSetAction } from '../../../../../../../../../store/model/actions/cardsActionSetAction';
import { cardsUpdateAction } from '../../../../../../../../../store/model/cards/actions/cardsUpdateAction';
import { getCard } from '../../../../../../../../../store/model/selectors/getCard';
import { root } from '../../../../../../../../../store/constants';

export const onCardClick = (
    e: React.MouseEvent,
    cardId: TCardId
): ThunkAction => {
    return (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        const card = getCard(getState(), cardId);
        if (card && card.listId === root.App.controller.movedFromList.getMovedFromListId()) {
            dispatch(segmentTrackAction(SegmentCardEvent.RETURNED_TO_MOVED_LIST, {
                name: SegmentCardOptions.TIME,
                value: root.App.controller.movedFromList.getTime(),
            }));
        }
        root.App.controller.movedFromList.resetMovedFromListId();
        dispatch(segmentTrackAction(SegmentCardEvent.CARD_CLICKED));
        dispatch(cardClick(e, cardId));
        dispatch(cardsActionSetAction(cardsUpdateAction({ [cardId]: { openedQuickLook: null } })));
    };
};
